import { FC } from 'react';
import { Listbox } from '@headlessui/react';
import { Controller } from 'react-hook-form';

import { ReactComponent as DropdownIcon } from 'assets/icons/drop-down.svg';

interface OptimizeWeeklyDurationProps {
  control: any;
}

const BLOCKS_OPTION = [
  { label: 'Always on', value: 0 },
  { label: '1 week', value: 1 },
  { label: '2 weeks', value: 2 },
  { label: '3 weeks', value: 3 },
];

const OptimizeWeeklyDurationDropdown: FC<OptimizeWeeklyDurationProps> = ({
  control,
}) => {
  return (
    <Controller
      control={control}
      name="optimizeWeeklyDuration"
      render={({ field }) => {
        return (
          <Listbox {...field}>
            {({ open }) => {
              return (
                <div className="relative text-14 leading-[2.1rem]">
                  <Listbox.Button
                    className={`relative w-full h-[4rem] pl-1.6 cursor-pointer rounded-[1rem] bg-white border-[0.5px] border-light-grey text-left shadow-primary hover:border-magenta hover:shadow-input-active outline-none ${
                      open ? 'border-magenta shadow-input-active' : ''
                    }`}
                  >
                    <span className="block pr-3 text-darkest-grey">
                      {
                        BLOCKS_OPTION.find(
                          (option) => option.value === field.value
                        )!.label
                      }
                    </span>
                    <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-1.6">
                      <DropdownIcon
                        className={`${
                          open ? 'fill-[#666]' : 'fill-[#ccc]'
                        } transition-[fill] shrink-0`}
                      />
                    </span>
                  </Listbox.Button>
                  <Listbox.Options className="absolute mt-0.8 w-full rounded-[0.8rem] bg-white py-1.5 text-base shadow-primary flex flex-col gap-y-1.5 z-20">
                    {BLOCKS_OPTION.map(({ label, value }) => (
                      <Listbox.Option
                        key={value}
                        className="relative cursor-default select-none pl-1.6"
                        value={value}
                      >
                        {({ selected }) => (
                          <span
                            className={`block truncate cursor-pointer hover:text-magenta ${
                              selected ? 'text-magenta' : ''
                            }`}
                          >
                            {label}
                          </span>
                        )}
                      </Listbox.Option>
                    ))}
                  </Listbox.Options>
                </div>
              );
            }}
          </Listbox>
        );
      }}
    />
  );
};

export default OptimizeWeeklyDurationDropdown;
